import { Download } from 'lucide-react';
import React from 'react';
import { Button, Spinner } from '@/Components/shadcn';
import { cn } from '@/lib/utils';

interface DownloadButtonProps extends React.ComponentProps<typeof Button> {
    label: string;
    loading?: boolean;
}

function DownloadButton({ label, loading, disabled, className, ...props }: DownloadButtonProps): React.JSX.Element {
    return (
        <Button
            type="button"
            variant="outline"
            size="sm"
            disabled={disabled || loading}
            className={cn('bg-card', className)}
            {...props}
        >
            {loading ? (
                <Spinner className="size-4" />
            ) : (
                <Download
                    className="size-4 shrink-0 text-inherit"
                    data-icon="inline-start"
                    aria-hidden
                    data-testid="DownloadIcon"
                />
            )}
            {label}
        </Button>
    );
}

export default DownloadButton;
